import StudentLessonRecording from "@/elements/components/session/student-lesson-recording";
import TutorLessonRecording from "@/elements/components/session/tutor-lesson-recording";
import Loader from "@/elements/components/shared/loader";
import { api } from "@/elements/components/utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { Fragment } from "react";

function LessonRecordingScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );
  const persona = currentUser?.persona;

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return persona === "student" ? (
    <StudentLessonRecording />
  ) : persona === "tutor" ? (
    <TutorLessonRecording />
  ) : (
    <Fragment />
  );
}

export default LessonRecordingScreen;
